<template>
  <div class="ForumChatThreadCardHeaderMainAsideHeaderMainAside" :class="classList">
    <LLPopper
      v-if="isReactionsEnabled"
      class="ForumChatThreadCardHeaderMainAsideHeaderMainAside__action"
      :offset="[0, 0]"
      tooltip-white
      :show.sync="isAnimatedReactionSilectorVisible"
      placement="top-start"
    >
      <template #trigger>
        <LLButton :tertiary-dark="!dark" :tertiary-white="dark" small>
          <template #icon-left>
            <ReactionAnimatedIcon />
          </template>
        </LLButton>
      </template>
      <template #tooltip>
        <LLTextareaEmoji show-animated-only @select="onReactionSelect" />
      </template>
    </LLPopper>
    <LLPopper
      v-if="isReactionsEnabled"
      class="ForumChatThreadCardHeaderMainAsideHeaderMainAside__action"
      :offset="[0, 0]"
      tooltip-white
      :show.sync="isReactionSilectorVisible"
      placement="top-start"
    >
      <template #trigger>
        <LLButton :tertiary-dark="!dark" :tertiary-white="dark" small>
          <template #icon-left>
            <ReactionIcon />
          </template>
        </LLButton>
      </template>
      <template #tooltip>
        <LLTextareaEmoji show-suggested @select="onReactionSelect" />
      </template>
    </LLPopper>
    <LLButton
      class="ForumChatThreadCardHeaderMainAsideHeaderMainAside__action"
      :tertiary-dark="!dark"
      :tertiary-white="dark"
      small
      :loading="loading"
      @click="onToggleSave"
    >
      <template #icon-left>
        <SavedPostsFilledIcon
          v-if="isSaved"
          class="ForumChatThreadCardHeaderMainAsideHeaderMainAside__saved-icon"
        />
        <SavedPostsIcon v-else />
      </template>
    </LLButton>
    <div class="ForumChatThreadCardHeaderMainAsideHeaderMainAside__action">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import LLButton from '@/components/common/ui-components/LLButton.vue'
import ReactionIcon from '@/assets/icons/ReactionIcon.vue'
import ReactionAnimatedIcon from '@/assets/icons/ReactionAnimatedIcon.vue'
import LLPopper from '@/components/utils/LLPopper.vue'
import LLTextareaEmoji from '@/components/common/LLTextarea/LLTextareaEmoji.vue'
import { ForumThreadState } from '@/common/enums'
import { ForumThreadModel } from '@/models/forum/forumThread'

import SavedPostsIcon from '@/assets/icons/SavedPostsIcon.vue'
import SavedPostsFilledIcon from '@/assets/icons/SavedPostsFilledIcon.vue'

export default {
  name: 'ForumChatThreadCardHeaderMainAsideHeaderMainAside',
  components: {
    LLTextareaEmoji,
    LLPopper,
    ReactionAnimatedIcon,
    ReactionIcon,
    SavedPostsIcon,
    SavedPostsFilledIcon,
    LLButton
  },
  props: {
    isReactionAnimationsEnabled: { type: Boolean, default: true },
    thread: { type: ForumThreadModel, required: true },
    dark: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false }
  },
  data() {
    return {
      isReactionSilectorVisible: false,
      isAnimatedReactionSilectorVisible: false,
      loading: false
    }
  },
  computed: {
    classList() {
      return {
        [`${this.$options.name}_mobile`]: this.mobile,
        [`${this.$options.name}_compact`]: this.compact
      }
    },
    isReactionsEnabled() {
      return this.thread?.state === ForumThreadState.ACTIVE
    },
    isSaved() {
      return this.thread?.isSaved ?? false
    }
  },
  methods: {
    onReactionSelect({ emoji: reaction }) {
      this.isReactionSilectorVisible = false
      this.isAnimatedReactionSilectorVisible = false
      this.$emit('reactionSelect', { reaction })
    },
    async onToggleSave() {
      if (this.loading) return
      this.loading = true
      try {
        const { saved } = await this.$api.forum.threads.toggleSave({
          chatId: this.thread.chatId,
          threadId: this.thread.id
        })
        this.$emit('toggleSave', { saved })
      } catch (e) {
        // silently fail
      }
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.ForumChatThreadCardHeaderMainAsideHeaderMainAside {
  $root: &;
  @apply flex ml-4;
  &__action {
    @apply ml-1;
    @at-root #{$root}_mobile & {
      @apply ml-0.5;
    }
    &:first-child {
      @apply ml-0;
    }
  }
  &__saved-icon {
    @apply text-primary-01;
  }
}
</style>
